import React, { Component } from "react";
import { FormGroup, ControlLabel } from "react-bootstrap";
import { FormError } from "./../../../../FormError";

export default class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: {
        value: "",
        isValid: "",
        message: "",
        hasErrorFocus: false
      }
    };
  }

  componentDidMount() {
    console.log("in SearchBar componentDidMount");
    this.setState({
      searchText: {
        isValid: true,
        value: "",
        message: ""
      }
    });
  }

  handleSubmit = event => {
    event.preventDefault();
    
    if (this.validateForm()) {
      console.log("form is valid");
      this.props.performSearch(this.state.searchText.value);
      this.setState({ searchText: { isValid: true, message: "", value: this.state.searchText.value } });
    } else {
      console.log("form is not valid");
      
      this.props.resetSearchResults();
      
      this.setState({
        searchText: {
          value: '',	
          isValid: false,
          message: "Error: please enter atleast one character"
        }
      });
    }
  };

  validateForm = () => {
    if (this.state.searchText.value === "") {
      return false;
    }
    return true;
  };

  getValidationState(isValid) {
    if (isValid === "" || isValid === undefined) {
      return null;
    }
    if (isValid) {
      return "success";
    } else {
      return "error";
    }
  }

  handleChange = event => {
    const value = event.target.value;
    this.setState({
      searchText: { value: value }
    });
  };

  render() {
    return (
      <div className="col-12">
        <form
          id="firstNetOrgSearchForm"
          name="firstNetOrgSearchForm"
          className="customForm"
          ref={form => (this.firstNetOrgSearchForm = form)}
          onSubmit={this.handleSubmit}
        >
          <div className="row">
            <ControlLabel>{this.props.information}</ControlLabel>

            <FormGroup
              id="organizationName"
              className="col-12 col-md-6"
              validationState={this.getValidationState(
                this.state.searchText.isValid
              )}
            >
              <ControlLabel>
                FirstNet Organization Name{" "}
                <strong className="text-red"> *</strong>
              </ControlLabel>
              <FormError errorMessage={this.state.searchText.message} />
              <input
                id="inpSearchText"
                className="form-control"
                aria-required="true"
                aria-describedby=""
                name="searchText"
                type="text"
                autoComplete="nope"
                onChange={this.handleChange}
                value={this.state.searchText.value}
              />
              <input
                // id="btnSubmit" // duplicate prop name
                name="submitButton"
                id="submitButton"
                className="button secondary light-bg"
                type="submit"
                value="Go"
                aria-label="Go"
              />
            </FormGroup>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/firstnet/search/organization/components/SearchBar.js